import { ReactNode, useState } from 'react';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

interface ApplicantHeaderWrapperProps {
    header: React.ReactNode;
}

// React 18 children-typing fix (same pattern as Collapsible above):
// `React.FC` no longer implies `children`, so declare it explicitly.
const ApplicantHeaderWrapper: React.FC<ApplicantHeaderWrapperProps & { children?: ReactNode }> = ({ header, children }) => {
    const [open, setOpen] = useState(true);
    return (
        <Box width="100%" position="relative">
            <IconButton
                disableRipple
                onClick={() => setOpen(!open)}
                style={{ position: 'absolute', right: 0, top: 0 }}
                color="primary"
            >
                {open ? <RemoveCircleIcon /> : <AddCircleIcon />}
            </IconButton>
            {!open && (
                <ButtonBase disableRipple style={{ width: '100%', justifyContent: 'flex-start' }} onClick={() => setOpen(!open)}>
                    {header}
                </ButtonBase>
            )}
            <Collapse in={open}>
                <Box padding=".5rem" paddingTop={0}>
                    {children}
                </Box>
            </Collapse>
        </Box>
    );
};

export default ApplicantHeaderWrapper;